import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class HeightWidthService {
    public _hw: IHeightWidth = {
        mainHeight: 0,
        mainWidth: 0,
        diagramPadding: 0,
        editHeight: 0,
        scrollHeadHeight: 0,
        scrollHeadWidth: 0,
        scrollHeadMarginTop: 0,
        scrollOffsetTop: 0,
        scrollOffsetBottom: 0,
        windowHeight: 0,
        windowWidth: 0,
        isBelowMediumBP: false,
        isBelowLargeBP: false
    };

    mainHW = new Subject<IHeightWidth>();

    getHW(): Observable<any> {
        return this.mainHW.asObservable();
    }

    sendHW(hw: any): void {
        //are we setting & sending new values?
        if (hw) {

            this._hw.mainHeight = hw.mainHeight || this._hw.mainHeight;
            this._hw.mainWidth = hw.mainWidth || this._hw.mainWidth;
            this._hw.diagramPadding = hw.diagramPadding || this._hw.diagramPadding;
            this._hw.editHeight = hw.editHeight || this._hw.editHeight;
            this._hw.scrollHeadHeight = hw.scrollHeadHeight || this._hw.scrollHeadHeight;
            this._hw.scrollHeadWidth = hw.scrollHeadWidth || this._hw.scrollHeadWidth;
            this._hw.scrollHeadMarginTop = hw.scrollHeadMarginTop || this._hw.scrollHeadMarginTop;
            this._hw.scrollOffsetTop = hw.scrollOffsetTop || this._hw.scrollOffsetTop;
            this._hw.scrollOffsetBottom = hw.scrollOffsetBottom || this._hw.scrollOffsetBottom;
            this._hw.windowHeight = hw.windowHeight || this._hw.windowHeight;
            this._hw.windowWidth = hw.windowWidth || this._hw.windowWidth;
            this._hw.isBelowMediumBP = hw.isBelowMediumBP;
            this._hw.isBelowLargeBP = hw.isBelowLargeBP;

            this.mainHW.next(this._hw);
        } else {
            //send values stored from the last call
            this.mainHW.next(this._hw);
        }
    }
}


export interface IHeightWidth {
    mainHeight: number;
    mainWidth: number;
    diagramPadding: number;
    editHeight?: number;
    scrollHeadHeight: number;
    scrollHeadWidth: number;
    scrollHeadMarginTop: number;
    scrollOffsetTop: number;
    scrollOffsetBottom: number; 
    windowHeight: number;
    windowWidth: number;
    isBelowMediumBP: boolean;
    isBelowLargeBP: boolean;
}